import axios from 'axios';

const fetchTimeEntries = async ({ labourerId, projectId, type, startTime, endTime, page, perPage }) => {
  const searchParams = new URLSearchParams();

  if (labourerId) searchParams.append('labourerId', labourerId);
  if (projectId) searchParams.append('projectId', projectId);

  if (type) searchParams.append('type', type);

  if (startTime) {
    searchParams.append('startTime', startTime);
    searchParams.append('endTime', endTime);
  }

  searchParams.append('page', page);
  searchParams.append('perPage', perPage);

  const { data: { timeEntries, count } } = await axios.get(`${process.env.REACT_APP_API_URL}/time-entries/?${searchParams.toString()}`);

  return {
    timeEntries,
    count
  };
};

const fetchOngoingTimeEntry = async (labourerId) => {
  const { data: ongoingTimeEntry } = await axios.get(`${process.env.REACT_APP_API_URL}/labourers/${labourerId}/ongoing-time-entry`);

  return ongoingTimeEntry;
}

const createTimeEntry = async (payload) => {
  const timeEntry = await axios.post(`${process.env.REACT_APP_API_URL}/time-entries`, payload);

  return timeEntry;
};

const updateTimeEntry = async (timeEntryId, payload) => {
  const timeEntry = await axios.put(`${process.env.REACT_APP_API_URL}/time-entries/${timeEntryId}`, payload);

  return timeEntry;
}

const removeTimeEntry = async (timeEntryId) => {
  await axios.delete(`${process.env.REACT_APP_API_URL}/time-entries/${timeEntryId}`);

  return timeEntryId;
}

const timeEntryService = {
  fetchTimeEntries,
  fetchOngoingTimeEntry,
  createTimeEntry,
  updateTimeEntry,
  removeTimeEntry
};

export default timeEntryService;
